import apiClient from "./apiClient";

export const DepartmentApi = {
    getDepartmenetInfo: async (depNum, sign) => {
        console.log(depNum);
        console.log(sign);
        const response = await apiClient
            .get(`/api/Reviews/GetDepNameByNumber?number=${depNum}&sign=${sign}`);
        return  response.data;
    }
}